import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(items) {
        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.items_cart_preview');
          itensCartPreview.innerHTML = '';
    
          items.forEach((item) => {
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
    
            let itemHTML = `
            <li class="cart-item">
              <figure>
                <img src="${item.image_medium}" alt="${item.name}">
              </figure>
              <div class="cart-item-content">
                <div class="cart-item-content-item">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                </div>
                <div class="cart-item-content-item">
                  ${variations}
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                </div>
              </div>
            </li>
            `;
    
            itensCartPreview.innerHTML += itemHTML;
          });
    
          // Adiciona o event listener para os botões de deletar
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function() {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });
        }
      }
    
      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function(data) {
        if (data && data.cart_data && data.cart_data.items) {
          updateCartPreview(data.cart_data.items);
        }
      });
    
      $(document).on("ajaxComplete", function(event, xhr, settings) {
        if (settings.url.includes('/api/front/cart/items/') && settings.type === 'POST') {
          let valid_status = [200, 201];
          if (valid_status.includes(xhr.status)) {
            const responseJson = xhr.responseJSON.cart_data.items;
            updateCartPreview(responseJson);
          }
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

document.addEventListener("DOMContentLoaded", function() {
  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  if (tabAccordions) {
    tabAccordions.forEach(function (tabAccordion, index) {
      tabAccordion.addEventListener('click', function () {
          tabAccordions.forEach(function (tab) {
              tab.classList.remove('active');
          });

          contentAccordions.forEach(function (content) {
              content.classList.remove('active');
          });
          
          tabAccordion.classList.add('active');
          contentAccordions[index].classList.add('active');
      });
    });
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  function loadSvg() {
     const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function(svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, {passive: true});

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  waitForElementToExist('#faixa-comunicado').then(element => {
    $('#faixa-comunicado').slick({
      arrows: false,
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      delay: 2000,
      speed: 700,

      responsive: [
          {
              breakpoint: 991,
              settings: 'unslick'
          }
      ]
    });
  });

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);


  // Funcionalidade para controlar altura da figcaption na seção sobre
  const aboutSection = document.querySelector('.product-list__section--sobre .about');
  
  if (aboutSection) {
    const figure = aboutSection.querySelector('img');
    const figcaption = aboutSection.querySelector('figcaption');
    const paragraphs = aboutSection.querySelectorAll('figcaption p');
    
    if (figure && figcaption && paragraphs.length > 0) {
      // Calcula o total de linhas de texto de todos os parágrafos
      let totalLines = 0;
      let totalParagraphHeight = 0;
      
      paragraphs.forEach(paragraph => {
        const computedStyle = window.getComputedStyle(paragraph);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const fontSize = parseFloat(computedStyle.fontSize);
        const actualLineHeight = lineHeight || fontSize * 1.4; // fallback para line-height
        
        const paragraphHeight = paragraph.offsetHeight;
        const paragraphLines = Math.round(paragraphHeight / actualLineHeight);
        
        totalLines += paragraphLines;
        totalParagraphHeight += paragraphHeight;
      });
      
      // Se o total de linhas for maior que 10, implementa o controle
      if (totalLines > 10) {
        // Calcula a altura da linha (usando o primeiro parágrafo como referência)
        const firstParagraph = paragraphs[0];
        const computedStyle = window.getComputedStyle(firstParagraph);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const fontSize = parseFloat(computedStyle.fontSize);
        const actualLineHeight = lineHeight || fontSize * 1.4;
        
        // Limita a exibição para 10 linhas
        const maxLines = 10;
        const maxHeight = maxLines * actualLineHeight;
        
        // Armazena as alturas originais dos parágrafos
        const originalHeights = [];
        paragraphs.forEach(paragraph => {
          originalHeights.push(paragraph.offsetHeight);
        });
        
        // Define a altura dos parágrafos para limitar a 10 linhas
        let currentHeight = 0;
        paragraphs.forEach((paragraph, index) => {
          const paragraphHeight = paragraph.offsetHeight;
          
          if (currentHeight + paragraphHeight <= maxHeight) {
            // Se ainda cabe, mantém a altura original
            currentHeight += paragraphHeight;
          } else {
            // Se não cabe mais, limita a altura restante
            const remainingHeight = maxHeight - currentHeight;
            if (remainingHeight > 0) {
              paragraph.style.height = remainingHeight + 'px';
              paragraph.style.overflow = 'hidden';
              paragraph.style.position = 'relative';
            } else {
              paragraph.style.height = '0px';
              paragraph.style.overflow = 'hidden';
              paragraph.style.position = 'relative';
            }
            currentHeight = maxHeight;
          }
        });
        
        // Cria o botão "Ver mais"
        const seeMoreBtn = document.createElement('button');
        seeMoreBtn.className = 'see-more';
        seeMoreBtn.textContent = 'Ver mais';
        
        // Adiciona o botão como última tag do figcaption
        figcaption.appendChild(seeMoreBtn);
        
        // Event listener para o botão
        seeMoreBtn.addEventListener('click', function() {
          if (paragraphs[0].style.height && paragraphs[0].style.height !== 'auto') {
            // Abre os parágrafos - restaura alturas originais
            paragraphs.forEach((paragraph, index) => {
              paragraph.style.height = 'auto';
              paragraph.style.overflow = 'visible';
            });
            seeMoreBtn.textContent = 'Ver menos';
          } else {
            // Fecha os parágrafos - aplica limitação novamente
            let currentHeight = 0;
            paragraphs.forEach((paragraph, index) => {
              const paragraphHeight = originalHeights[index];
              
              if (currentHeight + paragraphHeight <= maxHeight) {
                paragraph.style.height = 'auto';
                paragraph.style.overflow = 'visible';
                currentHeight += paragraphHeight;
              } else {
                const remainingHeight = maxHeight - currentHeight;
                if (remainingHeight > 0) {
                  paragraph.style.height = remainingHeight + 'px';
                  paragraph.style.overflow = 'hidden';
                  paragraph.style.position = 'relative';
                } else {
                  paragraph.style.height = '0px';
                  paragraph.style.overflow = 'hidden';
                  paragraph.style.position = 'relative';
                }
                currentHeight = maxHeight;
              }
            });
            seeMoreBtn.textContent = 'Ver mais';
          }
        });
      }
    }
  }
});